import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { API_BASE_URL as API_BASE } from "../../config/apiBaseUrl.js";

async function postTokenAction(pathSuffix, token, body = {}) {
  const response = await fetch(
    `${API_BASE}/api/notifications/${pathSuffix.replace(":token", encodeURIComponent(token))}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || "Request failed.");
  }
  return data;
}

export function NotificationUnsubscribePage() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    postTokenAction("unsubscribe", token)
      .then((body) => {
        setStatus("success");
        setMessage(body.message || "You have been unsubscribed.");
      })
      .catch((error) => {
        setStatus("error");
        setMessage(error.message);
      });
  }, [token]);

  return (
    <div className="midpoint-admin-page" style={{ maxWidth: 480, margin: "2rem auto" }}>
      <div className="panel-card">
        <h1>Email preferences</h1>
        {status === "loading" ? <p>Updating your preferences…</p> : <p>{message}</p>}
      </div>
    </div>
  );
}

export function NotificationPreferencesTokenPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("ready");
  const [message, setMessage] = useState("Use the links in your email to manage individual alert types.");

  return (
    <div className="midpoint-admin-page" style={{ maxWidth: 560, margin: "2rem auto" }}>
      <div className="panel-card">
        <h1>Manage notification preferences</h1>
        <p>{message}</p>
        <p className="muted">
          Token: <code>{token?.slice(0, 8)}…</code> (secure link — do not share)
        </p>
        {status === "error" ? <p>{message}</p> : null}
      </div>
    </div>
  );
}

export function NotificationDisableSavedSearchPage() {
  const { token } = useParams();
  const [message, setMessage] = useState("Disabling saved search alerts…");

  useEffect(() => {
    postTokenAction("saved-search/:token/disable", token)
      .then((body) => setMessage(body.message || "Saved search alerts disabled."))
      .catch((error) => setMessage(error.message));
  }, [token]);

  return (
    <div className="midpoint-admin-page" style={{ maxWidth: 480, margin: "2rem auto" }}>
      <div className="panel-card">
        <h1>Saved search alerts</h1>
        <p>{message}</p>
      </div>
    </div>
  );
}

export function NotificationDisableListingWatchPage() {
  const { token } = useParams();
  const [message, setMessage] = useState("Disabling listing watch…");

  useEffect(() => {
    postTokenAction("listing-watch/:token/disable", token)
      .then((body) => setMessage(body.message || "Listing watch disabled."))
      .catch((error) => setMessage(error.message));
  }, [token]);

  return (
    <div className="midpoint-admin-page" style={{ maxWidth: 480, margin: "2rem auto" }}>
      <div className="panel-card">
        <h1>Listing watch</h1>
        <p>{message}</p>
      </div>
    </div>
  );
}
